module.exports = __webpack_public_path__ + "img/operation.8cd4051b.png";